<script setup lang="ts">
    import Worksite from '~~/app/auth/models/Worksite';
    import WorksitePhase from '~~/app/auth/models/WorksitePhase';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const emit = defineEmits(['selected', 'changed']);

    interface Props extends FormInputProps {
        worksite: Worksite;
    }

    const props = defineProps<Props>();
    const inputData: FormInputData = useFormInput(props);
    const select = ref(null);
</script>

<template>
    <FormElement
        :inputData="inputData"
        @label-clicked="select?.show()"
    >
        <SelectWorksitePhase
            :initial-value="inputData.model"
            :worksite="worksite"
        ></SelectWorksitePhase>
    </FormElement>
</template>
